export const DISCOVER_PAGE_SIZE = 20;
